// ABOUTME: Maps metadata-declared candidate/job fields from the selected JOBAPPLICANT snapshot.
// ABOUTME: Prevents applicant-level fallback values from leaking between job contexts.

export const getJobContextCustomFields = (customFields: Compleo.IObject[]) =>
    customFields.filter((field) => field.jobContextField === true);

export const resolveJobContextCustomFieldsForView = (
    authenticatedCustomFields: Compleo.IObject[],
    metadataCustomFields: Compleo.IObject[],
    isExternalView: boolean
) =>
    getJobContextCustomFields(
        isExternalView ? metadataCustomFields : authenticatedCustomFields
    );

export const getJobContextCustomFieldNames = (
    fields: Compleo.IObject[]
): string[] =>
    fields
        .map((field) => field.customFieldName || field.fieldName)
        .filter(
            (fieldName): fieldName is string =>
                typeof fieldName === "string" && fieldName.length > 0
        );

export const isJobContextFieldsReady = (status: string) => status === "success";

export const applyJobContextCustomFieldValues = (
    valuesFromSource: Compleo.IObject,
    jobApplicantData: Compleo.IObject | undefined,
    jobContextFields: Compleo.IObject[]
) => {
    const textValues = new Map(
        (jobApplicantData?.cf_Text || []).map((field: Compleo.IObject) => [
            field.name,
            field.value
        ])
    );
    const objectValues = new Map(
        (jobApplicantData?.cf_Object || []).map((field: Compleo.IObject) => [
            field.name,
            field.value
        ])
    );

    for (const field of jobContextFields) {
        const fieldName = field.customFieldName || field.fieldName;
        if (!fieldName) {
            continue;
        }
        valuesFromSource[fieldName] = objectValues.has(fieldName)
            ? objectValues.get(fieldName)
            : textValues.get(fieldName);
    }

    return valuesFromSource;
};
